import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export default function MultiSelect(props: { id?: string, title: string, options: any, values: any, onSelectionChange: any }): JSX.Element {
    const { title, options, values, onSelectionChange } = props;
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const sortedOptions = options.sort((a, b) => a.name.localeCompare(b.name));
    return (
        <Autocomplete
            multiple
            options={sortedOptions}
            disableCloseOnSelect
            getOptionLabel={(option) => `${option.name} (${option.id})`}
            onChange={onSelectionChange}
            // defaultValue={defaultValues}
            value={values}
            isOptionEqualToValue={(option, value) => {
                return (option.id.toString() === value.id.toString())
            }}
            renderOption={(props, option, { selected }) => {
                return (    
                    <li {...props}>
                        <Checkbox
                            name={option.id.toString()}
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                        {`${option.name} (${option.id})`}
                    </li>
                )
            }}
            // style={{ width: 500 }}
            renderInput={(params) => (
                <TextField {...params} label={title} />
            )}
        />
    );
}